import React from "react";

export default function ModalHeader({title, subtitle}) {
    return (
        <div
            className={'d-flex justify-content-start align-items-center px-3'}
            style={{
                backgroundColor: '#1B365D', color: '#FFFFFF',
                height: '38px', minHeight: '38px',
                fontSize: '12px', fontWeight: '500',
                borderRadius: '9px 9px 0 0',
        }}>
            <div>{title}</div>
            <div
                style={{
                    margin: '0 6px',
                    height: '90%', width: '1px',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '50%',
                }}
            />
            <div style={{
                backgroundColor: '#24476E', color: '#FFFFFF',
                padding: '0 6px', borderRadius: '7px',
            }}>{subtitle}</div>
        </div>
    )
}